const STORAGE_KEY = 'ssoConnection';

export function rememberConnection(connection: string | undefined) {
  if (!connection?.trim()) return;

  try {
    localStorage.setItem(STORAGE_KEY, connection);
  } catch {
    // Storage can be disabled or full. Losing the remembered connection only costs the user the
    // Olio email screen, so it must never stop a login.
  }
}

/** Reads and forgets in one step, so a login attempt that never completes leaves nothing behind. */
export function takeRememberedConnection(): string | undefined {
  try {
    const connection = localStorage.getItem(STORAGE_KEY) || undefined;
    localStorage.removeItem(STORAGE_KEY);

    return connection;
  } catch {
    return undefined;
  }
}
